import { callOperation } from "../../../utils/apiHelper.js";

export const variantService = {
  async initializeGrid(token) {
    return await callOperation("get_headers", {}, token);
  },

  async getHeaders(token) {
    return await callOperation("get_headers", {}, token);
  },

  async switchVepDynamic(token, vepDynamic) {
    return await callOperation("switch_vep", { vepDynamic: vepDynamic }, token);
  },

  // ========================================
  // SAMPLE NAVIGATION METHODS
  // ========================================

  async getSampleInfo(token) {
    return await callOperation("get_sample_info", {}, token);
  },

  async navigateSamples(token, sample_low, sample_high) {
    return await callOperation("navigate_samples", {
      sample_low: sample_low,
      sample_high: sample_high
    }, token);
  },

  async nextSamples(token) {
    return await callOperation("navigate_direction", { direction: "next" }, token);
  },

  async previousSamples(token) {
    return await callOperation("navigate_direction", { direction: "previous" }, token);
  },

  async setSampleWindow(token, window_size) {
    return await callOperation("set_sample_window", {
      window_size: window_size
    }, token);
  },
};
